'use client'

import React from 'react'
import { IntroOverlay } from "@/components/intro/intro-overlay"
import HeroSection from "@/components/hero-section"

export function ClientHeroWrapper() {
  return (
    <IntroOverlay language="english">
      <div className="w-full overflow-hidden">
        <HeroSection />
      </div>
    </IntroOverlay>
  )
}